module.exports = __webpack_public_path__ + "img/available-on-the-app-store.9eadb2de.svg";